import React, { ReactNode } from "react";
import { Search, History } from "@material-ui/icons";
import { LogRequestPage } from "pages/LogRequest/LogRequest";
import { LogRequestHistory } from "pages/LogRequestHistory/LogRequestHistory";
import { Login } from "pages/Login/Login";
// import SlidesWrapper from "pages/Slides";

export interface AppRoute {
    title: string;
    path: string;
    originPath?: string;
    component: ReactNode;
    disableAppWrapper?: boolean;
    visibleTab?: boolean;
    protected: boolean;
}

export const MAIN_ROUTES: { [name: string]: AppRoute } = {
    login: {
        title: "Login",
        path: "/login",
        component: <Login />,
        disableAppWrapper: true,
        protected: false,
    },
    logRequest: {
        title: "Log Request",
        path: "/log/:logRequestId",
        component: <LogRequestPage />,
        protected: true,
    },
    logRequestNew: {
        title: "Log Request",
        path: "/log",
        component: <LogRequestPage />,
        protected: true,
    },
    logRequestHistory: {
        title: "History",
        path: "/history",
        component: <LogRequestHistory />,
        protected: true,
    },
};

export const SIDEBAR_LINKS = [
    {
        href: MAIN_ROUTES.logRequestNew.path,
        icon: Search,
        title: MAIN_ROUTES.logRequestNew.title,
    },
    {
        href: MAIN_ROUTES.logRequestHistory.path,
        icon: History,
        title: MAIN_ROUTES.logRequestHistory.title,
    },
    // {
    //   href: MAIN_ROUTES.config.path,
    //   icon: SettingsIcon,
    //   title: MAIN_ROUTES.config.title,
    // },
];
